<script lang="ts" setup>
import { computed } from 'vue'
import { DialCode, Color } from '@previo/codebooks'
import { PSpaceSize } from '../space/types'
import PFlag from '../flag/PFlag.vue'
import { PFlagSize } from '../flag/types'
import PSpace from '../space/PSpace.vue'
import PTextFormBody from '../typography/form/PTextFormBody.vue'
import { getFullPhoneNumber } from '../../composables/helpers/phone'
import { type InternationalPhoneNumber } from '../../types/InternationalPhoneNumber'

type Props = {
  internationalPhoneNumber: InternationalPhoneNumber
  withFlag?: boolean
  color?: Color
  strike?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  withFlag: false,
  color: Color.GREY_500,
  strike: false,
})

const countryDialCode = computed<DialCode>(() => {
  return DialCode.getById(props.internationalPhoneNumber.dialCodeId)
})

const fullPhoneNumber = computed<string>(() => {
  return getFullPhoneNumber(props.internationalPhoneNumber)
})
</script>

<template>
  <div class="p-flex p-items-center p-no-wrap">
    <template v-if="withFlag">
      <p-flag :size="PFlagSize.SMALL" :country-iso3="countryDialCode.country.iso3" />
      <p-space :mobile="PSpaceSize.XS" />
    </template>
    <p-text-form-body :text="fullPhoneNumber" :color="color" :strike="strike" />
  </div>
</template>
